export default "__VITE_ASSET__C16eT$7U__"